module.exports = __webpack_public_path__ + "img/asuransi-barang.87e26c00.svg";